var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468",
    "data-name": "Rectangle 3468",
    width: 13,
    height: 13,
    transform: "translate(1389 234)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354",
    transform: "translate(-1380 -225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7267",
    "data-name": "Group 7267",
    transform: "translate(-120 -86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3398",
    "data-name": "Rectangle 3398",
    width: 30,
    height: 30,
    rx: 6,
    transform: "translate(1500 311)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4685",
    "data-name": "Mask Group 4685",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1388.51 233.179)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_302",
    "data-name": "Ellipse 302",
    cx: 2.708,
    cy: 2.708,
    r: 2.708,
    transform: "translate(4.233 1.386)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.132
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M8.2,8.3H5.285a4.211,4.211,0,0,0-4.21,4.21h0a.316.316,0,0,0,.317.317H6.425",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.132,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_303",
    "data-name": "Ellipse 303",
    cx: 1.587,
    cy: 1.587,
    r: 1.587,
    transform: "translate(9.73 8.222)",
    fill: "none",
    stroke: "#0a64f9",
    strokeWidth: 1.132
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    cx: 0.521,
    cy: 0.521,
    r: 0.521,
    transform: "translate(10.797 9.289)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M10.867,11.309,9.048,13.128,7.8,13.346,8.015,12.1l1.822-1.822a1.457,1.457,0,0,0,.317.605A1.433,1.433,0,0,0,10.867,11.309Z",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.949,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/Permission.cea64bbc02d20cdef9d8aac7b1e8a326.svg";
export { ForwardRef as ReactComponent };